import { useTranslation } from 'react-i18next';
import LandingpageHeader from '../header/LandingpageHeader';
import Footer from './Footer';

export default function FooterContact() {
    const { t } = useTranslation();

    const onChangeHandler = (e: { preventDefault: () => void; target: any; }) => {
        const type = e.target.type;
        const name = e.target.name;

        const value = type === "checkbox"
            ? e.target.checked
            : e.target.value;

        // setData(prevData => ({
        //     ...prevData,  
        //     [name]: value
        // }));
    }

    const onSubmitHandler = (e: { preventDefault: () => void; target: any; }) => {
        e.preventDefault()
    }

    return (

        <div className="container flexdiv">

            <LandingpageHeader />

            <article>

                <h3 style={{ textAlign: 'center' }}>{t('deTranslation.pageContact.title')}</h3>


                
            

            </article>

            <Footer />
        </div>
    );
}
